import { create } from "zustand";
import type { PDA1081_R01ScanResultDto, ReturnItem } from "./PDA1081_R01Dto";

interface State {
  loading: boolean;
  setLoading: (v: boolean) => void;

  scanValue: string;
  setScanValue: (v: string) => void;

  scannedItem: PDA1081_R01ScanResultDto | null;
  setScannedItem: (i: PDA1081_R01ScanResultDto | null) => void;

  returnQty: number;
  setReturnQty: (q: number) => void;

  returnItems: ReturnItem[];
  addReturnItem: (item: ReturnItem) => void;
  removeReturnItem: (itemCd: string) => void;
  setReturnItems: (list: ReturnItem[]) => void;
  clearReturnItems: () => void;

  reset: () => void;
}

const usePDA1081_R01Store = create<State>((set) => ({
  loading: false,
  setLoading: (loading) => set({ loading }),

  scanValue: "",
  setScanValue: (scanValue) => set({ scanValue }),

  scannedItem: null,
  setScannedItem: (scannedItem) => set({ scannedItem }),

  returnQty: 0,
  setReturnQty: (returnQty) => set({ returnQty }),

  returnItems: [],
  addReturnItem: (item) => set((s) => ({ returnItems: [...s.returnItems, item] })),
  removeReturnItem: (itemCd) =>
    set((s) => ({ returnItems: s.returnItems.filter((i) => i.itemCd !== itemCd) })),
  setReturnItems: (returnItems) => set({ returnItems }),
  clearReturnItems: () => set({ returnItems: [] }),

  reset: () =>
    set({
      loading: false,
      scanValue: "",
      scannedItem: null,
      returnQty: 0,
      returnItems: [],
    }),
}));

export default usePDA1081_R01Store;
